export function createEntityReducer(entityKey, primaryKey = "_id") {
  const singularKey = entityKey.endsWith("s")
    ? entityKey.slice(0, -1)
    : entityKey;

  const currentKey = `current${singularKey[0].toUpperCase()}${singularKey.slice(
    1
  )}`;

  return function reducer(state, action) {
    switch (action.type) {
      case "FETCH_START":
        return { ...state, loading: true, error: null };

      case "FETCH_SUCCESS":
      case "REPLACE_ALL":
        return { ...state, [entityKey]: action.payload, loading: false };

      case "FETCH_ERROR":
        return { ...state, error: action.payload, loading: false };

      case "ADD":
        return {
          ...state,
          [entityKey]: [...state[entityKey], action.payload],
          [currentKey]: action.payload,
          message: `${singularKey} added successfully!`,
        };

      case "UPDATE":
        return {
          ...state,
          [entityKey]: state[entityKey].some(
            (item) => item[primaryKey] === action.payload[primaryKey]
          )
            ? state[entityKey].map((item) =>
                item[primaryKey] === action.payload[primaryKey]
                  ? action.payload
                  : item
              )
            : [...state[entityKey], action.payload], // fallback: add if not found
          [currentKey]: action.payload,
          message: `${singularKey} updated successfully!`,
        };

      case "PATCH_UPDATE":
        return {
          ...state,
          [entityKey]: state[entityKey].map((item) =>
            item[primaryKey] === action.payload[primaryKey]
              ? { ...item, ...action.payload }
              : item
          ),
          [currentKey]: action.payload,
          message: `${singularKey} partially updated successfully!`,
        };

      case "DELETE":
        return {
          ...state,
          [entityKey]: state[entityKey].filter(
            (item) => item[primaryKey] !== action.payload
          ),
          [currentKey]:
            state[currentKey]?.[primaryKey] === action.payload
              ? null
              : state[currentKey],
          message: `${singularKey} deleted successfully!`,
        };

      case "SET_CURRENT":
        return { ...state, [currentKey]: action.payload };

      case "SET_MESSAGE":
        return { ...state, message: action.payload };

      default:
        return state;
    }
  };
}
